import { render, staticRenderFns } from "./ybsbgmxList.vue?vue&type=template&id=080968cf&scoped=true&"
import script from "./ybsbgmxList.vue?vue&type=script&lang=js&"
export * from "./ybsbgmxList.vue?vue&type=script&lang=js&"
import style0 from "./ybsbgmxList.vue?vue&type=style&index=0&id=080968cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080968cf",
  null
  
)

export default component.exports